import { useCallback, useMemo, useState } from 'react';
import { TFiltersProps } from '../../components/filters/Filters';
import { TGiftType, useQueryAllSubscriptionAssemblingGiftsNew } from '../../entities/gifts/queries';
import { isDependant } from '../../entities/recipients/shared';
import { TDependantType, TGiftStatuses, TGiftTypes } from '../../generated/graphql';
import { GiftAssembling, TGiftAssemblingColumnDetails } from './GiftAssembling';

export const subscriptionGiftsAssemblingColumnsDetails: TGiftAssemblingColumnDetails[] = [
  {
    name: 'Todo',
    destinationColumns: [TGiftStatuses.Assembling],
    nextPhase: TGiftStatuses.Assembling,
    id: TGiftStatuses.Todo
  },
  {
    name: 'Assembling',
    destinationColumns: [TGiftStatuses.Todo, TGiftStatuses.Qa],
    nextPhase: TGiftStatuses.Qa,
    id: TGiftStatuses.Assembling
  },
  {
    name: 'QA',
    destinationColumns: [TGiftStatuses.Todo, TGiftStatuses.Assembling, TGiftStatuses.Done],
    nextPhase: TGiftStatuses.Done,
    id: TGiftStatuses.Qa
  },
  {
    name: 'Done',
    destinationColumns: [],
    nextPhase: undefined,
    id: TGiftStatuses.Done
  }
];

export const SubscriptionGifts = () => {
  const [giftTypeFilter, setGiftTypeFilter] = useState<TGiftTypes>();
  const [recipientTypeFilter, setRecipientTypeFilter] = useState<TDependantType | 'employee'>();

  const filterMethod = useCallback(
    (gift: TGiftType) => {
      if (giftTypeFilter != null && gift.type !== giftTypeFilter) return false;

      if (recipientTypeFilter != null) {
        const recipient = gift.recipient;
        if (recipient == null) return false;

        if (isDependant(recipient)) {
          if (recipient.type !== recipientTypeFilter) return false;
        } else
          // THIS IS AN EMPLOYEE
          if (recipientTypeFilter !== 'employee') return false;
      }

      return true;
    },
    [giftTypeFilter, recipientTypeFilter]
  );

  const extraFilters = useMemo(() => {
    const filtersList: TFiltersProps['filters'] = [];

    filtersList.push(
      {
        label: 'Event Type',
        name: 'eventType',
        onChange: (v: any) => {
          setGiftTypeFilter(v != null ? (v as TGiftTypes) : undefined);
        },
        options: [
          {
            label: 'Work Anniversary',
            value: TGiftTypes.WorkAnniversary
          },
          {
            label: 'Birthday',
            value: TGiftTypes.Birthday
          }
        ],
        type: 'singleSelect',
        value: giftTypeFilter
      },
      {
        label: 'Recipient Type',
        name: 'recipientType',
        onChange: (v: any) => {
          setRecipientTypeFilter(v != null ? (v as TDependantType | 'employee') : undefined);
        },
        options: [
          {
            label: 'Employee',
            value: 'employee'
          },
          {
            label: 'Spouse',
            value: TDependantType.SignificantOther
          },
          {
            label: 'Child',
            value: TDependantType.Child
          },
          {
            label: 'Pet',
            value: TDependantType.Pet
          }
        ],
        type: 'singleSelect',
        value: recipientTypeFilter
      }
    );

    return filtersList;
  }, [giftTypeFilter, recipientTypeFilter]);

  return <GiftAssembling columnsDetails={subscriptionGiftsAssemblingColumnsDetails} extraFilterFunction={filterMethod} extraFilters={extraFilters} query={useQueryAllSubscriptionAssemblingGiftsNew} />;
};
